import React from 'react';
import {useTeam} from '../../context/TeamContext';
import ImprovementPointsList from '../planning/ImprovementPointsList';
export default function SummaryFocusSidebar({mapId}) {const {teamId}=useTeam();return <ImprovementPointsList teamId={teamId} mapId={mapId}/>;}
